import { css, type Theme } from '@emotion/react';

export const examRegistrationCard = css`
  position: relative;

  width: 100%;
  border-radius: 8px;
`;

export const examRegistrationCardBody = css`
  display: flex;
  flex-direction: column;
  gap: 16px;

  align-items: center;
`;

export const title = css`
  text-align: center;
`;

export const actions = css`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const closeButton = css`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export const emailLink = (theme: Theme) => css`
  color: ${theme.colors.primary[500]};
`;
